/**
 * 发布弹窗控制器
 * 用于控制全局发布弹窗的显示/隐藏和配置管理
 */
import { reactive, readonly } from 'vue'

export interface PostDialogConfig {
  hasHistory?: boolean
  scene?: 'challenge' | 'home' | 'normalChallenge'
  checkedLength?: number
  noPost?: boolean
  tabType?: 'history' | 'loacl'
  generateType?: number
  enablePrompt?: number
  challengeId?: string
  checkedImages: any[]
  fromWhere?: string
  postType?: 'image' | 'video'
  title?: string
  wantable?: boolean
  [key: string]: any

  // 回调函数
  postFailed?: () => void
  postSuccess: (data: any) => void
}

interface PostDialogState {
  visible: boolean
  config: PostDialogConfig | null
}

const state = reactive<PostDialogState>({
  visible: false,
  config: null
})

export function usePostDialog() {
  const showPostDialog = (config: PostDialogConfig) => {
    state.config = config
    state.visible = true
  }

  const hidePostDialog = () => {
    state.visible = false
    state.config = null
  }

  return {
    state: state,
    showPostDialog,
    hidePostDialog
  }
}
